import { render, staticRenderFns } from "./RentalCard.vue?vue&type=template&id=6683f9f4&scoped=true"
import script from "./RentalCard.vue?vue&type=script&lang=js"
export * from "./RentalCard.vue?vue&type=script&lang=js"
import style0 from "./RentalCard.vue?vue&type=style&index=0&id=6683f9f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683f9f4",
  null
  
)

export default component.exports